module.exports = __webpack_public_path__ + "static/sad-smurgle-0a93490546a8d710913ff71ffbb40c4a.svg";